import { css } from "lit";
import { Style } from "../Styles";
import { ThemeDark } from "../ThemeDark";

export default css`
    ${ThemeDark}
    ${Style}    

    :host {
        background-color: var(--surface-bg-color);
        box-sizing: border-box;
        display: block;
        margin: 0;
        padding: 1em;
    }

    * {
        --divider-color: var(--sl-color-neutral-200);
    }

    .app-title {
        padding-left: 0.3rem;
        padding-bottom: 0.3rem;
        font-variant-caps: all-petite-caps;
        color: white;
    }

    .app-title-icon {
        font-size: 0.8em;
    }

    .unresolved main {
        opacity: 0;
    }

    .container-sl {
        width: 100%;
        height: 100%;
        background-color: var(--body-bg-color);
        padding: 0rem;

        overflow-y: auto;
        min-height: 100%;
        padding: 0rem;

        display: flex;
        flex-direction: column;
    }

    .header-container {
        width: 100%;
        padding-top: 0.5em;
        padding-bottom: 0.5em;
        background-color: var(--ds-surface-bg-color);
    }

    .header {
        font-size: 1.5rem;
        display: flex;
        align-items: center;
        flex-direction: horizontal;
        color: white;
    }

    .body {
        position: relative;
        overflow: hidden;
        flex: 1;
        background-color: lightgray;
    }

    .footer {
        display: flex;
        flex-direction: column;
        column-gap: 0.5em;
        background-color: var(--surface-bg-color);
        padding: 0.5rem 0.5rem 0 0.5rem;
        align-items: center;
        overflow-y: hidden;
    }

    .filter-footer-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-items: flex-end;
        width: 100%;
        gap: var(--flex-gap);
    }

    .filter-showing-row {
        justify-content: end;
    }

    .footer span {
        margin-left: auto;
        font-style: italic;
    }

    .container-sl sl-icon:not(.app-title-icon) {
        position: absolute;
        border-radius: var(--sl-border-radius-small);
        background: var(--divider-color);
        color: var(--sl-color-neutral-600);
        padding: 0.5rem 0.125rem;
    }

    .version {
        text-align: right;
    }

    .nav-direction {
        width: 100%;
        justify-content: center;
        padding-right: 0.5rem;
        background-color: var(--surface-bg-color);
    }

    .nav-direction > span {
        flex: 1;
        text-align: center;
        color: white;
    }

    .compass {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: -12em;
    }

    .track-position-switch {
        margin-left: 1em;
    }

    .track-position-switch::part(base) {
        color: white;
    }

    ds-data-table {
        width: 100%;
        height: 100%;
        overflow: auto;
    }

    sl-drawer::part(title) {
        color: white;
    }

    sl-drawer::part(header) {
        background-color: var(--surface-bg-color);
    }

    sl-drawer::part(header-actions) {
        color: white;
    }

    sl-icon::part(base),
    sl-icon-button::part(base) {
        color: white;
    }

    sl-drawer::part(panel) {
        overflow: unset;
    }

    #release-notes-dialog::part(panel) {
        width: 90%;
    }

    sl-drawer {
        --size: 30rem;
        color: black;
    }

    ds-places-map {
        height: 100%;
        width: 100%;
    }

    ds-media-import {
        padding: 0em;
        height: 100%;
    }

    ds-navigator {
        position: absolute;
        bottom: 0;
        width: 26em;
        height: 8em;
        overflow-y: clip;
        left: 50%;
        transform: translateX(-50%);
    }

    .gallery-loading {
        width: 100%;
        height: 100%;
        align-items: center;
        justify-content: center;
    }

    .gallery-loading sl-spinner {
        font-size: 10em;
        --track-width: 10px;
        --speed: 2s;
        --indicator-color: var(--accent-color);
        --track-color: lightgray;
    }

    .current-location {
        margin-left: auto;
        margin-right: auto;
    }

    .settings-footer {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .filter-bar {
        width: 100%;
    }

    .header-buttons {
        margin-left: auto;
        margin-right: 0.2em;
        display: flex;
        align-items: center;
    }

    .sync-message {
        position: absolute;
        display: flex;
        flex-direction: row;
        bottom: 0.5em;
        justify-content: center;
        width: 100%;
    }

    .sync-message div {
        background-color: #b17e1f;
        padding: 0.75em;
        border-radius: 1em;
    }

    .sync-message sl-progress-bar {
        --indicator-color: darkgray;
        --height: 0.5em;
    }

    .search-bar {
        position: absolute;
        top: 1em;
        left: 0.5em;
        right: 0.5em;
        height: 3em;
        background-color: transparent;
        border-radius: 0.25em;
        gap: 0.6em;
        display: flex;
        flex-direction: column;
    }

    .sign-up::part(base) {
        color: white;
    }

    .overlay-filter-editor {
        position: absolute;
        left: 0;
        top: 3em;
        padding: 0;
        border-radius: 1em;
        color: black;
        overflow-y: auto;
        max-width: 100vw;
    }

    .overlay-filter-editor.open {
        height: calc(-18em + 100vh);
        width: 25em;
        background-color: rgba(255, 255, 255, 0.96);
        padding: 1em;
    }

    .map-controls {
        height: 3em;
        float: right;
        position: absolute;
        right: 0;
        top: 3em;
    }

    .filter-bar-filter-editor {
        display: none;
    }

    .overlay-map-marker-select {
        width: 10em;
    }

    sl-select::part(expand-icon) {
        color: black;
    }

    @media only screen and (max-width: 1024px) {
        .overlay-filter-editor.open {
            height: calc(100vh - 8em);
            width: calc(100vw - 1em);
            width: 100%;
        }
    }
`;
